const o = (e, r) => {
  const n = new URL(r);
  return n.hostname = `${e}.${n.hostname}`, n.toString().replace(/\/$/, "");
}, s = "0123456789abcdefghijklmnopqrstuvwxyz", a = (e) => {
  if (e <= 0n)
    return "0";
  let r = "";
  for (; e > 0n; ) {
    const n = e % 36n;
    r = s[Number(n)] + r, e = e / 36n;
  }
  return r;
}, c = (e, r) => {
  try {
    const n = new URL(e), t = new URL(r);
    return n.hostname.endsWith(t.hostname);
  } catch {
    return !1;
  }
};
export {
  o as a,
  a as b,
  c as i
};
